import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=3c21134c"
import script from "./user-avatar.vue?vue&type=script&lang=ts"
export * from "./user-avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports